import React, { useContext, useEffect, useRef } from "react";
import { Grid, Input, Typography } from "@material-ui/core";
import CobeeButton from "../../../../app/components/CobeeButton";
import uploadImage from "../../../../assets/img/upload-multiple-employees.png";
import { translate } from "../../../../infrastructure/translate/localization";
import useStyles from "./styles";
import legend from "./constants";
import EmployeeActionsContext from "../../../../infrastructure/Contexts/components/actions/EmployeeActionsWrapper/context";

export default function ModalLegendUploadEmployees() {
  const {
    container,
    modalTitle,
    modalSubtitle,
    containerLegend,
    greenPoint,
    legendText,
    fileInput,
  } = useStyles();

  const fileInputElement = useRef(null);

  const { downloadEmployeeTemplate, uploadMultipleEmployees } = useContext(
    EmployeeActionsContext
  );

  useEffect(() => {
    downloadEmployeeTemplate();
  }, [downloadEmployeeTemplate]);

  const handleFileChange = (e) => {
    const filename = e.target.files[0];
    uploadMultipleEmployees({ filename });
  };

  return (
    <Grid container className={container}>
      <Grid item container xs={12} justify="center">
        <img src={uploadImage} alt="upload-modal-img" />
      </Grid>
      <Grid item container xs={12} justify="center">
        <Typography variant="h6" className={modalTitle}>
          {translate("upload-employees-section.modal-legend-title")}
        </Typography>
      </Grid>
      <Grid item container xs={12} justify="center">
        <Typography variant="body2" className={modalSubtitle}>
          {translate("upload-employees-section.modal-legend-subtitle")}
        </Typography>
      </Grid>
      <Grid container justify="center">
        {legend.map((item) => (
          <Grid
            item
            container
            xs={12}
            key={item.id}
            className={containerLegend}
          >
            <div className={greenPoint} />
            <Typography variant="body2" className={legendText}>
              {item.text}
            </Typography>
          </Grid>
        ))}
      </Grid>

      <Grid item container xs={12} justify="center">
        <Input
          type="file"
          inputRef={fileInputElement}
          onChange={handleFileChange}
          className={fileInput}
        />
        <CobeeButton
          onClick={() => fileInputElement.current.click()}
          styleType="primaryBig"
        >
          {translate("upload-employees-section.upload-template").toUpperCase()}
        </CobeeButton>
      </Grid>
    </Grid>
  );
}
